// extracted by mini-css-extract-plugin
module.exports = {"footer":"MobileFooter_footer__1_x2O","singleCta":"MobileFooter_singleCta__2kFdB"};